import {
  formatNumber,
  formatDate,
  waitForPdfMakeReady,
} from "./pdfReceiptGenerator";

/**
 * Class สำหรับสร้าง Receipt Detail PDF
 */
export class ReceiptDetailPDFBuilder {
  constructor(data) {
    this.data = data;
    this.header = data.print_header || {};
    this.items = this.extractItems(data.datashowAllDetail || []);
    this.currencyPrint = data.currency_print || "THB";
    this.exchangeRate = data.exchange_rate || 1;
    this.currency_show = data.currency_show || "THB";
  }

  /**
   * แยก items จาก datashowAllDetail
   */
  extractItems(datashowAllDetail) {
    const allItems = [];
    datashowAllDetail.forEach((group) => {
      if (Array.isArray(group)) {
        group.forEach((item) => {
          allItems.push(item);
        });
      }
    });
    return allItems;
  }

   generateMainStatement(documentType = "ORIGINAL") {
    const mainContent = [];
    // ===== หน้าที่ 1 =====
    mainContent.push(
      // ตารางและข้อมูล
      this.generateItemsTable(this.items),
    );

 

    return mainContent;
  }

  generateItemsTable(items) {

    const tableWidthsBody = [355, 70, 70];

  return {
    stack: [
      // ตารางที่ 2: ข้อมูลจริง (วางทับ)
      {
        // absolutePosition: { x: 40, y: 268 }, // ต่ำกว่า header เล็กน้อย
        layout: {
      hLineWidth: function (i, node) {
        if (i === 0 || i === 1) return 1;
        // if (i === node.table.body.length) return 1;
        return 0;
      },
      vLineWidth: function (i, node) {
        return (i === 0 || i === 1 || i === node.table.widths.length) ? 1 : 0;
      },
      hLineColor: function (i, node) {
        return 'black';
      },
      vLineColor: function (i, node) {
        return 'black';
      }
    },
     layout: 'noBorders',
    margin: [2, -25, 0, 0],
        table: {
          widths: tableWidthsBody,
          body: [
        [
          {
            text: '',
            fontSize: 10,
            bold: true,
            margin: [5, 5, 5, 5]
          },
          {
            text: '',
            fontSize: 10,
            bold: true,
            alignment: 'right',
            margin: [5, 5, 5, 5]
          },
          {
            text: '',
            fontSize: 10,
            bold: true,
            alignment: 'right',
            margin: [5, 5, 5, 5]
          },
        ],
        ...items.map(item => [
          {
            text: item.description || "",
            fontSize: 9,
            margin: [2, 3, 2, 3],
          },
          {
            text: item.quantity ? formatNumber(item.quantity) : "",
            fontSize: 9,
            alignment: "center",
            margin: [2, 3, 2, 3],
          },
          {
            text: item.amount ? formatNumber(item.amount) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          },
        ]),
      ], 
      heights: (rowIndex) => {
        if (rowIndex === 0) return 20;
        return 'auto';
      }
          
        },
      },
    ]
  };
}

  /**
   * สร้าง Header ของเอกสาร
   */
  createHeaderDetail() {
    return {
      columns: [
        {
          width: "50%",
          stack: [
            {
              text: this.header.com_eng_1 || "DEJ-UDOM & ASSOCIATES LTD.",
              fontSize: 11,
              bold: true,
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_eng_2 || "ATTORNEY AT LAW",
              fontSize: 8,
              bold: true,
              margin: [0, 0, 0, 1],
            },
            {
              text:
                this.header.com_thai ||
                "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
              fontSize: 8,
              margin: [0, 0, 0, 1],
            },
          ],
        },
        {
          width: "50%",
          stack: [
            {
              text:
                this.header.com_add_name || "CHARN ISSARA TOWER 1, 2nd FLOOR,",
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_no || "942/69 RAMA IV ROAD,",
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                this.header.com_add_city || "KWAENG SURIYAWONG, KHET BANGRAK,",
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_country || "BANGKOK 10500, THAILAND",
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_tel || "Tel : 0-2233-0055, 0-2233-0068",
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text: this.header.com_add_email || "E-MAIL : account@dejudom.com",
              fontSize: 7,
              alignment: "right",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                this.header.com_add_tax_id ||
                'TAX ID. No. 0105534015348/"HEAD OFFICE"',
              fontSize: 7,
              alignment: "right",
              bold: true,
            },
          ],
        },
      ],
      margin: [0, 0, 0, 10],
    };
  }

  /**
   * สร้าง Title ของเอกสาร
   */
  createTitleDetail() {
    return {
      stack: [
        {
          text: this.header.com_title || "RECEIPT / TAX INVOICE",
          fontSize: 14,
          bold: true,
          alignment: "center",
          margin: [0, 15, 0, 2],
        },
        {
          text: this.header.com_title_th || "ใบเสร็จรับเงิน / ใบกำกับภาษี",
          fontSize: 12,
          bold: true,
          alignment: "center",
          margin: [0, 0, 0, 10],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 0, 0, 10],
        },
      ],
      margin: [0, 0, 0, 0],
    };
  }

  /**
   * สร้างข้อมูลลูกค้า
   */
  createCustomerInfoDetail() {
    const addressLines = (this.header.addressall || "").split("\n");
    const filteredAddress = addressLines
      .filter((line) => line.trim() !== "" && line.trim() !== ",")
      .join(", ");

    const rightColumnStack = [
      {
        text: `No. / เลขที่ : ${this.header.inv_id || "________"}`,
        fontSize: 9,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
      {
        text: `Date / วันที่ : ${formatDate(this.header.invoice_date) ||
          "______________"}`,
        fontSize: 9,
        alignment: "right",
        margin: [0, 0, 0, 5],
      },
    ];

    // เพิ่ม Exchange Rate เฉพาะเมื่อไม่ใช่ THB
    if (this.currencyPrint !== "THB") {
      rightColumnStack.push({
        text: `Exchange Rate : ${this.exchangeRate || "______________"}`,
        fontSize: 9,
        alignment: "right",
      });
    }

    return {
      columns: [
        {
          width: "70%",
          stack: [
            {
              columns: [
                {
                  width: 60,
                  text: "To / ถึง:",
                  fontSize: 9,
                },
                {
                  width: "*",
                  text: this.header.customer_name || "Customer Name",
                  fontSize: 9,
                  bold: true,
                },
              ],
              margin: [0, 0, 0, 3],
            },
            {
              columns: [
                {
                  width: 60,
                  text: "",
                  fontSize: 8,
                },
                {
                  width: "*",
                  text: filteredAddress || "Address",
                  fontSize: 8,
                },
              ],
              margin: [0, 0, 0, 3],
            },
            {
              columns: [
                {
                  width: 60,
                  text: "Tax ID:",
                  fontSize: 9,
                },
                {
                  width: "*",
                  text: `${this.header.customer_taxid || "__________________"}`,
                  fontSize: 9,
                },
              ],
            },
          ],
        },
        {
          width: "30%",
          stack: rightColumnStack,
        },
      ],
      margin: [0, 0, 0, 10],
    };
  }

   createFixTable() {
        const tableWidths = [361, 70, 80];
    return {
      stack: [
            // ตารางที่ 1: กรอบพื้นฐาน (ขอบและความสูงคงที่)
      {
        // absolutePosition: { x: 40, y: 243 },
        absolutePosition: { x: 40, y: -255 },
         layout: {
        hLineWidth: function(i, node) {
          if (i === 0 || i === 1) {
            return 1;
          }
          return 0;
        },
        vLineWidth: function(i) {
          return 1;
        },
        paddingLeft: function() {
          return 0;
        },
        paddingRight: function() {
          return 0;
        },
        paddingTop: function() {
          return 0;
        },
        paddingBottom: function() {
          return 0;
        },
      },
      margin:[0,0,0,0],
        table: {
          headerRows: 1,
          widths: tableWidths,
          body: [
            // Header row
            [
              {
        text: "Description / รายการ",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
      {
        text: "Quantity / จำนวน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
      {
        text: "Amount / จำนวนเงิน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
            ],
            // แถวว่างสำหรับกำหนดความสูง
            [
              { text: '', margin: [5, 3, 5, 3] },
              { text: '', margin: [5, 3, 5, 3] },
              { text: '', margin: [5, 3, 5, 3] },
            ],
          ],
          heights: [25, 224]
        },
      },
      ],
    };
  }

  /**
   * สร้างตารางรายการสินค้า/บริการ (Detail)
   */
  createItemsTableDetail() {
    const tableWidths = ["*", 70, 80]; // 3 คอลัมน์: Description, Quantity, Amount

    const headerRow = [
      {
        text: "Description / รายการ",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
      {
        text: "Quantity / จำนวน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
      {
        text: "Amount / จำนวนเงิน",
        fontSize: 9,
        bold: true,
        alignment: "center",
        margin: [2, 3, 2, 3],
      },
    ];

    const bodyRows = [];
    const minRows = 7; // จำนวนแถวขั้นต่ำ

    for (let i = 0; i < minRows; i++) {
      if (i < this.items.length) {
        const item = this.items[i];

        const row = [
          {
            text: item.description+item.description+item.description+item.description || "",
            fontSize: 9,
            margin: [2, 3, 2, 3],
          },
          {
            text: item.quantity ? formatNumber(item.quantity) : "",
            fontSize: 9,
            alignment: "center",
            margin: [2, 3, 2, 3],
          },
          {
            text: item.amount ? formatNumber(item.amount) : "",
            fontSize: 9,
            alignment: "right",
            margin: [2, 3, 2, 3],
          },
        ];

        bodyRows.push(row);
      } else {
        // แถวว่าง
        const emptyRow = [
          {
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          },
          {
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          },
          {
            text: "",
            fontSize: 9,
            margin: [2, 15, 2, 15],
          },
        ];
        bodyRows.push(emptyRow);
      }
    }

    return {
      table: {
        headerRows: 1,
        widths: tableWidths,
        body: [headerRow, ...bodyRows],
      },
      layout: {
        hLineWidth: function(i, node) {
          if (i === 0 || i === 1 || i === node.table.body.length) {
            return 1;
          }
          return 0;
        },
        vLineWidth: function(i) {
          return 1;
        },
        paddingLeft: function() {
          return 0;
        },
        paddingRight: function() {
          return 0;
        },
        paddingTop: function() {
          return 0;
        },
        paddingBottom: function() {
          return 0;
        },
      },
      margin: [0, 0, 0, 0],
    };
  }

  /**
   * สร้างตารางสรุปยอด (Detail)
   */
  createSummaryTableDetail() {
    const subTotal = this.header.sub_total || 0;
    const taxRate = this.header.tax_rate || "7.00";
    const taxAmount = this.header.tax_rate_amount || 0;
    const grandTotal = this.header.amount_total || 0;

    const summaryWidths = [361, 70, 80]; // 3 คอลัมน์

    const summaryRows = [];

    // Sub Total Row
    const subTotalRow = [
      {
        text: "Sub Total / รวมเป็นเงิน",
        fontSize: 9,
        bold: true,
        alignment: "left",
        margin: [2, 3, 2, 3],
        colSpan: 2,
      },
      { text: "" },
      {
        text: formatNumber(subTotal),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      },
    ];

    summaryRows.push(subTotalRow);

    if (this.header.company_inv !== "L") {
    // VAT Row
    const vatRow = [
      {
        text: `Value Added Tax / ภาษีมูลค่าเพิ่ม (${taxRate} %)`,
        fontSize: 9,
        bold: true,
        alignment: "left",
        margin: [2, 3, 2, 3],
        colSpan: 2,
      },
      { text: "" },
      {
        text: formatNumber(taxAmount),
        fontSize: 9,
        alignment: "right",
        margin: [2, 3, 2, 3],
      },
    ];

    summaryRows.push(vatRow);
  }

    // Grand Total Row
    const grandTotalRow = [
      {
        text: "Grand Total / ยอดรวม",
        fontSize: 9,
        bold: true,
        alignment: "left",
        margin: [2, 3, 2, 3],
        colSpan: 2,
      },
      { text: "" },
      {
        text: formatNumber(grandTotal),
        fontSize: 9,
        bold: true,
        alignment: "right",
        margin: [2, 3, 2, 3],
      },
    ];

    summaryRows.push(grandTotalRow);

    return {
      table: {
        widths: summaryWidths,
        body: summaryRows,
      },
      layout: {
        hLineWidth: function(i, node) {
          return 1;
        },
        vLineWidth: function(i) {
          return 1;
        },
        hLineColor: function() {
          return "black";
        },
        vLineColor: function() {
          return "black";
        },
        paddingLeft: function() {
          return 0;
        },
        paddingRight: function() {
          return 0;
        },
        paddingTop: function() {
          return 0;
        },
        paddingBottom: function() {
          return 0;
        },
      },
      margin: [0, 0, 0, 0],
    };
  }

  /**
   * สร้างตัวอักษรจำนวนเงิน (Detail)
   */
  createAmountInWordsDetail() {
    const amountText = this.data.textamount_total_en || "";

    // ตรวจสอบภาษาของ customer_name
    const checker_th = /([\u0E00-\u0E7F]+)/gmu;
    const isThaiCustomer = checker_th.test(this.header.customer_name || "");

    let displayText = "";
    if (isThaiCustomer) {
      // ถ้าชื่อลูกค้าเป็นภาษาไทย
      displayText = `${amountText}`;
    } else {
      // ถ้าชื่อลูกค้าเป็นภาษาอังกฤษ
      displayText = `(${amountText}) ${this.currencyPrint || "USD"}`;
      displayText = displayText.replace("US", "USD").replace("USDD", "USD");
    }

    const widths = [361, 70, 80]; // 3 คอลัมน์

    const cells = [
      {
        text: displayText,
        fontSize: 9,
        alignment: "center",
        margin: [5, 8, 5, 8],
        fillColor: "#d8d8d8",
        colSpan: 3,
      },
      {},
      {},
    ];

    return {
      table: {
        widths: widths,
        body: [cells],
      },
      layout: {
        hLineWidth: function() {
          return 0;
        },
        vLineWidth: function() {
          return 1;
        },
        hLineColor: function() {
          return "black";
        },
        vLineColor: function() {
          return "black";
        },
        paddingLeft: function() {
          return 0;
        },
        paddingRight: function() {
          return 0;
        },
        paddingTop: function() {
          return 0;
        },
        paddingBottom: function() {
          return 0;
        },
      },
      margin: [0, 0, 0, 0],
    };
  }

  /**
   * สร้างเงื่อนไขการชำระเงิน
   */
  createPaymentConditions() {
    const paymentBy = this.data.payment_by_print || "";
    const paymentDetail = this.header.payment_detail || "";

    const cashChecked = paymentBy === "Cash" || paymentBy === "cash";
    const transferChecked = paymentBy === "Transfer" || paymentBy === "Bank";
    const chequeChecked = paymentBy === "Cheque" || paymentBy === "cheque";

    return {
      table: {
        widths: [513],
        body: [
          [
            {
              stack: [
                {
                  text: "Payment Conditions:",
                  fontSize: 9,
                  bold: true,
                  margin: [2, 5, 2, 3],
                },
                {
                  columns: [
                    {
                      width: "auto",
                      canvas: cashChecked
                        ? [
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 4,
                              r2: 4,
                              lineColor: "black",
                            },
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 2,
                              r2: 2,
                              color: "black",
                            },
                          ]
                        : [
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 4,
                              r2: 4,
                              lineColor: "black",
                            },
                          ],
                      margin: [10, 0, 5, 0],
                    },
                    {
                      width: "auto",
                      text: "Cash/เงินสด",
                      fontSize: 9,
                      margin: [0, 0, 20, 0],
                    },
                    {
                      width: "auto",
                      canvas: transferChecked
                        ? [
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 4,
                              r2: 4,
                              lineColor: "black",
                            },
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 2,
                              r2: 2,
                              color: "black",
                            },
                          ]
                        : [
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 4,
                              r2: 4,
                              lineColor: "black",
                            },
                          ],
                      margin: [0, 0, 5, 0],
                    },
                    {
                      width: "auto",
                      text: "Transfer/โอนเงิน",
                      fontSize: 9,
                      margin: [0, 0, 20, 0],
                    },
                    {
                      width: "auto",
                      canvas: chequeChecked
                        ? [
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 4,
                              r2: 4,
                              lineColor: "black",
                            },
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 2,
                              r2: 2,
                              color: "black",
                            },
                          ]
                        : [
                            {
                              type: "ellipse",
                              x: 5,
                              y: 5,
                              r1: 4,
                              r2: 4,
                              lineColor: "black",
                            },
                          ],
                      margin: [0, 0, 5, 0],
                    },
                    {
                      width: "auto",
                      text: "Cheque/เช็คธนาคาร",
                      fontSize: 9,
                      margin: [0, 0, 20, 0],
                    },
                    {
                      width: "auto",
                      text: "No./เลขที่ : " + (this.data.bank_no_show || ""),
                      fontSize: 9,
                    },
                  ],
                  margin: [2, 3, 2, 5],
                },
              ],
              margin: [2, 0, 2, 0],
            },
          ],
          [
            {
              text: `Payment Details / รายละเอียด:${
                paymentDetail ? "  " + paymentDetail : ""
              }`,
              fontSize: 9,
              margin: [2, 5, 2, 20],
            },
          ],
        ],
      },
      layout: {
        hLineWidth: function(i, node) {
          if (i === 0 || i === node.table.body.length) {
            return 1;
          }
          return 0;
        },
        vLineWidth: function() {
          return 1;
        },
        hLineColor: function() {
          return "black";
        },
        vLineColor: function() {
          return "black";
        },
        paddingLeft: function() {
          return 0;
        },
        paddingRight: function() {
          return 0;
        },
        paddingTop: function() {
          return 0;
        },
        paddingBottom: function() {
          return 0;
        },
      },
      margin: [0, 0, 0, 15],
    };
  }

  /**
   * สร้างกล่องลายเซ็น
   */
  createSignatureBox() {
    return {
      columns: [
        {
          width: "50%",
          text: "",
        },
        {
          width: "50%",
          table: {
            widths: ["*"],
            body: [
              [
                {
                  stack: [
                    {
                      text: "",
                      margin: [0, 0, 0, 35],
                    },
                    {
                      canvas: [
                        {
                          type: "line",
                          x1: 30,
                          y1: 0,
                          x2: 200,
                          y2: 0,
                          lineWidth: 1,
                        },
                      ],
                      margin: [0, 0, 0, 5],
                    },
                    {
                      text: "Authorized Signature / ผู้รับเงิน",
                      fontSize: 9,
                      alignment: "center",
                      margin: [0, 0, 0, 10],
                    },
                    {
                      text: "Date/วันที่ _______________________",
                      fontSize: 9,
                      alignment: "center",
                      margin: [0, 0, 0, 10],
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function() {
              return 1;
            },
            vLineWidth: function() {
              return 1;
            },
            hLineColor: function() {
              return "black";
            },
            vLineColor: function() {
              return "black";
            },
          },
        },
      ],
      margin: [0, 0, 0, 15],
    };
  }

  /**
   * สร้างหมายเหตุท้ายเอกสาร
   */
  createFooterNote() {
    return {
      stack: [
        {
          text:
            "This receipt will be valid when the company has received the payment into the bank account.",
          fontSize: 8,
          alignment: "center",
          margin: [0, 5, 0, 0],
        },
        {
          text:
            "ใบเสร็จรับเงินนี้จะสมบูรณ์เมื่อบริษัทได้รับชำระเงินเข้าในบัญชีธนาคารเรียบร้อยแล้ว",
          fontSize: 8,
          alignment: "center",
        },
      ],
      margin: [0, 10, 0, 0],
    };
  }

  /**
   * สร้างเนื้อหาทั้งหมด
   */
  build() {
    const content = [];
    // content.push(this.createHeaderDetail());
    // content.push(this.createTitleDetail());
    // content.push(this.createCustomerInfoDetail());
    content.push(this.createItemsTableDetail());
    // content.push(this.createSummaryTableDetail());
    // content.push(this.createAmountInWordsDetail());
    // content.push(this.createPaymentConditions());
    // content.push(this.createSignatureBox());
    // content.push(this.createFooterNote());
    return content;
  }

  /**
   * สร้าง Document Definition สำหรับ pdfMake
   */

  getDocDefinition() {
    const originalContent = this.generateMainStatement("ORIGINAL");
    return {
      pageSize: "A4",
      pageMargins: [40, 276, 40, 340],
      content: [...originalContent],
  header: (currentPage, pageCount) => {
      // แสดงในทุกหน้า (ลบ if condition ออก)
      return {
        stack: [
          this.createHeaderDetail(),
          this.createTitleDetail(),
          this.createCustomerInfoDetail(),
        ],
        margin: [40, 40, 40, 10],
      };
    },
            footer: (currentPage, pageCount) => {
      //  if(currentPage == 1){
        return {
          stack: [
            this.createFixTable(),
            this.createSummaryTableDetail(),
            this.createAmountInWordsDetail(),
            this.createPaymentConditions(),
            this.createSignatureBox(),
            this.createFooterNote()
          ],
          margin: [40, 0, 40, 0],
        };
        // }
      },
      defaultStyle: {
        font: "Sarabun",
        fontSize: 10,
      },
    };
  }
}

/**
 * ฟังก์ชันหลักสำหรับสร้าง Receipt Detail PDF
 * @param {Object} data - ข้อมูลสำหรับสร้าง PDF
 * @returns {Promise<boolean>}
 */
export const generateReceiptDetailPDF = async (data) => {
  try {
    await waitForPdfMakeReady();
    const builder = new ReceiptDetailPDFBuilder(data);
    const docDefinition = builder.getDocDefinition();
    pdfMake.createPdf(docDefinition).open();
    console.log("✅ สร้าง Receipt Detail PDF สำเร็จ");
    return true;
  } catch (error) {
    console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
    throw error;
  }
};

/**
 * ฟังก์ชันสำหรับดาวน์โหลด PDF แทนการเปิดในหน้าต่างใหม่
 * @param {Object} data - ข้อมูลสำหรับสร้าง PDF
 * @param {string} filename - ชื่อไฟล์ที่ต้องการดาวน์โหลด
 * @returns {Promise<boolean>}
 */
export const downloadReceiptDetailPDF = async (
  data,
  filename = "receipt-detail.pdf",
) => {
  try {
    await waitForPdfMakeReady();
    const builder = new ReceiptDetailPDFBuilder(data);
    const docDefinition = builder.getDocDefinition();
    pdfMake.createPdf(docDefinition).download(filename);
    console.log("✅ ดาวน์โหลด Receipt Detail PDF สำเร็จ");
    return true;
  } catch (error) {
    console.error("❌ เกิดข้อผิดพลาดในการดาวน์โหลด PDF:", error);
    throw error;
  }
};

/**
 * ฟังก์ชันสำหรับพิมพ์ PDF โดยตรง
 * @param {Object} data - ข้อมูลสำหรับสร้าง PDF
 * @returns {Promise<boolean>}
 */
export const printReceiptDetailPDF = async (data) => {
  try {
    await waitForPdfMakeReady();
    const builder = new ReceiptDetailPDFBuilder(data);
    const docDefinition = builder.getDocDefinition();
    pdfMake.createPdf(docDefinition).print();
    console.log("✅ เปิดหน้าต่างพิมพ์ Receipt Detail PDF สำเร็จ");
    return true;
  } catch (error) {
    console.error("❌ เกิดข้อผิดพลาดในการพิมพ์ PDF:", error);
    throw error;
  }
};
